import { useEffect, useState } from 'react';
import { useDashboardContext } from './Context';
import { useAuthContext } from '../../contexts/AuthContext';
import { DashboardService } from './service';

const service = new DashboardService();

const formatCurrency = (value: number) =>
    value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const formatPercent = (value: number) => `${value.toFixed(1)}%`;

export default function TeamDashboard() {
    const { startAt, endAt, atendenteId } = useDashboardContext();
    const { user } = useAuthContext();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const params: any = { startAt, endAt };
                if (user?.admin || user?.root) {
                    if (atendenteId) params.attendantId = atendenteId;
                }
                const response = await service.getTime(params);
                setData(response.data);
            } catch (error) {
                console.error('Erro ao carregar dashboard de time', error);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [startAt, endAt, atendenteId, user?.admin, user?.root]);

    if (!data) {
        return (
            <div className="card sf-dashboard-panel">
                <div className="card-body">{loading ? 'Carregando...' : 'Sem dados'}</div>
            </div>
        );
    }

    return (
        <div className="card sf-dashboard-panel">
            <div className="card-body">
                <h3 className="text-lg font-semibold">Performance do time</h3>
                <div className="overflow-x-auto mt-4">
                    <table className="table table-sm table-zebra">
                        <thead>
                            <tr>
                                <th>Atendente</th>
                                <th>Faturamento</th>
                                <th>Atendimentos</th>
                                <th>Ocupação</th>
                                <th>Rebooking</th>
                                <th>Cancelamentos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(data.attendants || []).map((row: any) => (
                                <tr key={row.attendantId}>
                                    <td>{row.name}</td>
                                    <td>{formatCurrency(row.totalRevenue || 0)}</td>
                                    <td>{row.totalAppointments}</td>
                                    <td>{formatPercent(row.occupancyPercent || 0)}</td>
                                    <td>{formatPercent(row.rebookingRate || 0)}</td>
                                    <td>{row.totalCanceled}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
